import {
  FileValue,
  MyNumberRawValue,
  RefkeyValueType,
} from "@graffer-inc/form-schema";
import { AttachFileWithURL, MyNumberWithID } from "../application-entity";
import {
  CloudGovFileRefKeyExchanger,
  CloudGovMyNumberRefKeyExchanger,
} from "./cloud-gov-refkey-registry";

export interface FileHolder {
  files: Array<AttachFileWithURL>;
  formatFileURLWithRefKey?: (refKey: string) => string | null;
}

export class ReadonlyFileRefKeyRegistry
  implements CloudGovFileRefKeyExchanger<AttachFileWithURL>
{
  constructor(public readonly holder: FileHolder) {}

  getRegistry(): {
    [key: string]: AttachFileWithURL;
  } {
    const result: {
      [key: string]: AttachFileWithURL;
    } = {};
    this.holder.files.forEach((f) => {
      if (f.refKey) {
        result[f.refKey] = f;
      }
    });
    return result;
  }

  async refkeyToValue(refkey: string): Promise<FileValue> {
    const uploadFile = this.holder.files.find((f) => f.refKey === refkey)!;
    return {
      name: uploadFile.name,
      type: uploadFile.type,
      uri: this.holder.formatFileURLWithRefKey
        ? this.holder.formatFileURLWithRefKey(uploadFile.refKey!) || ""
        : "",
      size: uploadFile.size / 1024 / 1024,
    };
  }

  clearRefKey(): void {
    throw new Error("should not be called");
  }

  valueToRefkey(): Promise<RefkeyValueType> {
    throw new Error("should not be called");
  }
}

export interface MyNumberHolder {
  myNumbers?: Array<MyNumberWithID>;
}

export class ReadonlyMyNumberRefKeyRegistry
  implements CloudGovMyNumberRefKeyExchanger<MyNumberRawValue>
{
  constructor(public readonly holder: MyNumberHolder) {}

  refkeyToValue(refkey: string): MyNumberRawValue {
    const v = this.holder.myNumbers?.find((v) => v.refKey === refkey);
    return {
      // 必ず値が存在する前提である. 最終4数値は初期リリースではなかったためオプショナル
      value: v!.last4Digit || "",
      skipValidate: !!v,
    };
  }

  valueToRefkey(_: string): string {
    throw new Error("should not be called");
  }

  clearRefKey(): void {
    throw new Error("should not be called");
  }

  getRegistry(): { [p: string]: MyNumberRawValue } {
    const result: {
      [key: string]: MyNumberRawValue;
    } = {};
    this.holder.myNumbers?.forEach((m) => {
      result[m.refKey] = {
        value: m.last4Digit || "",
        // この段階は申請が完了していてマイナンバーは検証済みなので、エラーを出さない
        skipValidate: true,
      };
    });
    return result;
  }
}
